// extracted by mini-css-extract-plugin
module.exports = {"MonthStickyRange":"MonthStickyRange__1iqLX"};